import BaseHelper from './moment-base';
import moment from 'moment';

export default class Moment extends BaseHelper {
  compute(params) {
    super.compute(...arguments);
    return moment(...params);
  }
}
